import { SorterParamValue } from "./types";

export const SorterParam = <T = unknown>() => ({
  encode(
    value: SorterParamValue<T> | SorterParamValue<T>[]
  ): string[] | undefined {
    if (!value) {
      return undefined;
    }

    const values = Array.isArray(value) ? value : [value];

    return values.reduce<string[]>((reduced, { columnKey, order }) => {
      if (!columnKey) {
        return reduced;
      }

      return [...reduced, [columnKey, order].filter(Boolean).join(":")];
    }, []);
  },

  decode(
    value: string | (string | null)[] | null | undefined
  ): SorterParamValue<T> | SorterParamValue<T>[] | undefined {
    if (!value) {
      return undefined;
    }

    const values = Array.isArray(value) ? value : [value];

    return values.reduce<SorterParamValue<T>[]>((reduced, item) => {
      if (!item) {
        return reduced;
      }

      const [columnKey, order] = item.split(":");

      if (!columnKey || !(order === "ascend" || order === "descend")) {
        return reduced;
      }

      return [...reduced, { columnKey, order }];
    }, []);
  },
});
